import api from './api';

export const getTasks = (categoryId) =>
  api.get('/tasks/', { params: categoryId ? { category_id: categoryId } : {} });

export const getTask = (id) => api.get(`/tasks/${id}`);

export const createTask = (data) => api.post('/tasks/', data);

export const updateTask = (id, data) => api.put(`/tasks/${id}`, data);

export const deleteTask = (id) => api.delete(`/tasks/${id}`);
